export default "__VITE_ASSET__GEWkRg21__"